import {useEffect, useState} from 'react';
import {useSelector, useDispatch} from 'react-redux';
import Selector from '../../../selectors/layers/main';
import {notify as notifyAction} from '../../../reducers/app/actions';
import User from './user';
import Games from './games';
import Jackpots from './jackpots';
import Toolbar from './toolbar';
import ModalsUtil from '../../../utils/modals';
import Language from '../../../language';
import Animation from './animation';
import ImageUtil from '../../../utils/image';
import language from '../../../language';

export default () => {
    const {user, notify: reducerNotify} = useSelector(Selector),
          [initialized, setInitialized] = useState(false),
          dispatch = useDispatch();

    const [notify, setNotify] = useState({
        text: null,
        key: 0
    });

    useEffect(() => {
        setNotify(reducerNotify);
    }, [reducerNotify]);

    useEffect(() => {
        if(!initialized) {
            Animation.init();
            setInitialized(true);
        }
    }, [initialized]);

    useEffect(() => {
        if(notify.key === 0)
            return;
    
        clearTimeout(window.notifyHideTimeout);
        clearTimeout(window.removeNotifyTextTimeout);

        const notify_element = document.querySelector('.notify');

        if(!notify_element)
            return;

        notify_element.classList.remove('animate__bounceOut');
        notify_element.classList.add('animate__bounceIn');

        window.notifyHideTimeout = setTimeout(() => {
            notify_element.classList.remove('animate__bounceIn');
            notify_element.classList.add('animate__bounceOut');

            window.removeNotifyTextTimeout = setTimeout(() => {
                setNotify({...notify, text: null});
            }, 600);
        }, 2e3);
    }, [notify.key]); 

    if(!user)
        return <></>;

    return (
        <>
            <div className="screen main-page">
                <Toolbar />
                {notify.text && (
                    <div className="notify-container">
                        <div className="notify">{notify.text}</div>
                    </div>
                )}

                <div className="header animate__animated animate__fadeInDown">
                    <div className="login">
                        {user.username}
                    </div>
                    <Jackpots /> 
                    <div className="version">
                        v0.0.1
                    </div>
                </div>

                <Games />

                <div className="bottom animate__animated animate__fadeInUp">
                    <div className="left">
                        <User user={user} />

                        <div className="bonuses-section" style={{marginLeft: "120px"}} onClick={e => ModalsUtil.open('bonus')}>
                            <div className="bonus">
                                <div className="icon">
                                    <ImageUtil
                                        path="/images/main/icons/bonus-icon.png"
                                        alt="Bonus" />
                                </div>
                                <div className="name">{Language('layers.main.bottom.bonus')}</div>
                            </div>
                        </div>
                    </div>

                    <div className="center">
                        <div className="main-animation"></div>
                    </div>

                    <div className="right">
                        <div className="bonuses-section">
                            <div className="bonus" onClick={e => {
                                // dispatch(notifyAction(language('notifications.bonus.soon')));
                                ModalsUtil.open('wheel')
                            }}>
                                <div className="icon">
                                    <ImageUtil
                                        path="/images/main/icons/wheel-icon.png"
                                        alt="Wheel" />
                                </div>
                                <div className="name">{Language('layers.main.bottom.wheel')}</div>
                            </div>

                            <div className="bonus" onClick={e => ModalsUtil.open('profile')}>
                                <div className="icon">
                                    <ImageUtil
                                        path="/images/main/icons/settings-icon.png"
                                        alt="Settings" />
                                </div>
                                <div className="name">{Language('layers.main.bottom.settings')}</div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}